<template>
	<div class="institution_contents">
		<el-row class="contents ">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery ">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="90px">
					<el-form-item label="机构名称"><el-input v-model="queryParams.name" placeholder="机构名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd"  v-has="'btn_add'">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width:100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="name" label="机构名称">
						<template slot-scope="scope" >
							<el-button type="text" @click="goInstitution(scope.row)">{{scope.row.name}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="contactName" label="联系人"></el-table-column>
					<el-table-column prop="contactInformation" label="联系方式"></el-table-column>
					<el-table-column prop="logo" label="机构logo" width="80px">
						<template slot-scope="scope" >
							<el-image style="width: 50px; height: 50px" :src="scope.row.logo" fit="fit"  :preview-src-list="[scope.row.logo]"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="code" label="CODE码" width="80px"></el-table-column>
					<el-table-column prop="expireDays" label="剩余天数" width="80px">
						<template slot-scope="scope">
							{{scope.row.expireDays}}
							<i class="el-icon-edit"  style="color:blue;cursor: pointer;" @click="handleLog(scope.row)"></i>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="80px">
						<template slot-scope="scope" >
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" @click="handleEdit(scope.row)" type="primary"  v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="danger"  v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="122px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="机构名称" prop="name"><el-input v-model="addOrUpdateForm.name"></el-input></el-form-item>
						<el-form-item label="联系人" prop="contactName"><el-input v-model="addOrUpdateForm.contactName"></el-input></el-form-item>
						<el-form-item label="联系方式" prop="contactInformation"><el-input v-model="addOrUpdateForm.contactInformation"></el-input></el-form-item>
						<el-form-item label="公司logo" prop="logo">
							<el-upload class="avatar-uploader" action="/api/system/file/upload"  :multiple="false" 
							     :headers="headers" :show-file-list="false" :on-success="handleUploadSuccess" :before-upload="beforeUpload">
								<img v-if="addOrUpdateForm.logo" :src="addOrUpdateForm.logo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog v-loading="logLoading" title="剩余天数" :visible.sync="dialogLogVisible" width="900px" :close-on-click-modal="false"   @close="handleLogCloase">
			<div slot="" style="margin-top: 0px;">
				<el-row >
					<el-col :span="24" class="handleLogQuery">
						<el-form :inline="true" :model="addOrUpdateDaysForm" style="margin: 0px;" class="form" size="small" label-width="80px">
							<h3 style="margin-top: -15px;">修改天数</h3>
							<el-form-item label="剩余天数" label-width="80px">
								<el-input-number v-model="addOrUpdateDaysForm.expireDays"  label="请输入剩余天数"></el-input-number>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="saveLog">确认</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24">
						<h3 >记录列表</h3>
						<el-table :data="logs" stripe border  tooltip-effect="dark">
							<el-table-column type="index" label="序号"></el-table-column>
							<el-table-column prop="oldExpireDays" label="操作前"></el-table-column>
							<el-table-column prop="diffDays" label="操作天数"></el-table-column>
							<el-table-column prop="expireDays" label="操作后"></el-table-column>
							<el-table-column prop="creatorName" label="操作人"></el-table-column>
							<el-table-column prop="createTime" label="操作时间"></el-table-column>
						</el-table>
						<!-- 分页 -->
						<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryLogParams.currentPage"
							:page-size="queryLogParams.pageSize" :total="queryLogParams.totalNum" @size-change="pageLogSizeChange" @current-change="pageLogCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogLogVisible = false">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import SearchBase from '@/components/layout/base/base-search-front.vue';

	export default {
		extends: SearchBase,
		data() {
			return {
				url: 'institution',
				name: '机构',
				headers:{},
				rules: {
					name: [{
						required: true,
						message: '机构名称不能为空',
						trigger: 'change'
					}],
					contactName: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'change'
					}],
					contactInformation: [{
						required: true,
						message: '联系方式不能为空',
						trigger: 'change'
					}]
				},
				dialogLogVisible:false,
				logs:[],
				logLoading:true,
				queryLogParams: {
					currentPage: 1,
					pageSize: 10,
					createDates:[],
					totalNum:0
				},
				addOrUpdateDaysForm:{
					id:null,
					expireDays:0
				}
			};
		},
		methods: {
			handleLog(row) {
				this.logLoading = true;
				this.addOrUpdateDaysForm.id=row.id;
				this.addOrUpdateDaysForm.expireDays=row.expireDays;
				this.queryLogParams.institutionId=row.id;
				this.queryLogParams.type="expire_days";
				this.dialogLogVisible=true;
				this.queryLogParams.currentPage =1;
				this.logs=[]
				this.queryLog();
			},
			handleLogCloase(){
				this.logs=[]
				this.getList();
			},
			queryLog(){
				this.$http({
					method: 'POST',
					url: 'mngr/cm/institution/log/query',
					data: this.queryLogParams,
				}).then((res)=> {
					res.data.data.forEach(item => {
						var data = JSON.parse(item.content);
						item.diffDays = data.diffDays;
						item.expireDays = data.expireDays;
						item.oldExpireDays = data.oldExpireDays;
					})
					this.logs=res.data.data;
					this.queryLogParams.totalNum = res.data.page.totalNum;
					this.queryLogParams.totalPage=res.data.page.totalPage;
				})
			},
			handleDeviceShare(row){
				this.$refs.devicesShare.show(row.id);
			},
			handleUploadSuccess(res, file) {
				this.addOrUpdateForm.logo = res.data;
				this.$forceUpdate(); 
			},
			goInstitution(data){
				window.open(location.origin+"/"+data.code+"/login")
			},
			pageLogCurrentChange(val) {
				// 分页
				this.queryLogParams.currentPage = val;
				this.queryLog();
			},
			pageLogSizeChange(val) {
				//调整每页显示条数
				this.queryLogParams.pageSize = val;
				this.queryLogParams.currentPage = 1;
				this.queryLog();
			},
			saveLog(){
				this.$http({
					method: 'POST',
					url: 'institution/updateExpireDays',
					data: this.addOrUpdateDaysForm,
				}).then((res) => {
					this.successMessage('更新成功')
					this.queryLog()
				})
			}
		},
		mounted: function() {
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
		}
	};
</script>

<style scoped>
	.avatar-uploader-icon{
		width: 128px;
		height: 128px;
		line-height: 128px;
	}
</style>


// WEBPACK FOOTER //
// src/view/system/institution.vue